<sw-modal
    class="moorl-feature-unlocker"
    v-if="open"
    :title="$tc('moorl-feature-unlocker.modal.title')"
    @modal-close="closeModal"
>
    <p>
        {{ $tc('moorl-feature-unlocker.modal.message1') }}
    </p>
    <p class="moorl-support-link">
        <a
            href="https://store.shopware.com/moorl87443379024/features-add-on-foundation.html"
            rel="noopener"
            target="_blank"
        >
            {{ $tc('moorl-feature-unlocker.modal.title') }}
        </a>
    </p>
    <p>
        <moorl-support-link path="/MoorlFoundation/features-premium/"/>
    </p>
    <table>
        <tr>
            <th style="width: 180px">Feature</th>
            <th>Description</th>
            <th style="width: 60px">FREE</th>
        </tr>
        <tr>
            <td>CMS Elements</td>
            <td>
                Additional CMS elements "Buy list, Downloads, HTML tag, Share, Table of contents"
                and following.
            </td>
            <td>
                <mt-icon
                    name="regular-checkmark"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>Demo assistant</td>
            <td>
                Many moori plugins have demo packages, you can install them by `One-Click`.
                <moorl-support-link path="/MoorlFoundation/demo-assistant/"/>
            </td>
            <td>
                <mt-icon
                    name="regular-checkmark"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>Sorting</td>
            <td>
                Some plugins have sorting options for listings. You can translate and configure them.
            </td>
            <td>
                <mt-icon
                    name="regular-checkmark"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>`Animate.css` configuration by CSS selector</td>
            <td>
                In the moori Foundation plugin configuration you can configure
                `On Scroll` and `On Load` animations for any elements by CSS selectors,
                supported by Animate.css. This feature may be removed if its not usable
                without jQuery support.
            </td>
            <td>
                <mt-icon
                    name="regular-checkmark"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>CMS responsive block configuration</td>
            <td>
                Hide and show your blocks on different viewports of your customers device.
            </td>
            <td>
                <mt-icon
                    name="regular-times"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>CMS `Animate.css` element configuration</td>
            <td>
                Configure `On Scroll` and `On Load` animations for your CMS elements.
                Fully supported Animate.css.
            </td>
            <td>
                <mt-icon
                    name="regular-times"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>CMS config saver</td>
            <td>
                Makes is possible to save a CMS element and copy it multiple times into new
                CMS elements.
            </td>
            <td>
                <mt-icon
                    name="regular-times"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>CMS section "Bootstrap Grid"</td>
            <td>
                Enables a new section. This can have multiple full adjustable columns with
                sticky feature and responsive viewport configuration with Bootstrap.
            </td>
            <td>
                <mt-icon
                    name="regular-times"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>CMS section "Slider"</td>
            <td>
                Enables a new section. This can be configured as a powerful and
                responsive slider. It will also replace the slider blocks from
                moori Foundation.
            </td>
            <td>
                <mt-icon
                    name="regular-times"
                    size="16"
                />
            </td>
        </tr>
        <tr>
            <td>CMS blocks Columns/Grid/Slider</td>
            <td>
                A set with 30+ block layouts.
            </td>
            <td>
                <mt-icon
                    name="regular-times"
                    size="16"
                />
            </td>
        </tr>
    </table>
    <template #modal-footer>
        <mt-button @click="closeModal">
            {{ $tc('moorl-feature-unlocker.modal.actions.close') }}
        </mt-button>
    </template>
</sw-modal>